<template>
  <div class="tax-charge-selector">
    <v-card-subtitle class="pa-0 mb-3 text-base">
      税サ
    </v-card-subtitle>

    <v-row dense>
      <v-col cols="6">
        <v-card
          :outlined="value !== 'normal'"
          :color="value === 'normal' ? 'primary' : ''"
          :dark="value === 'normal'"
          :class="['tax-card', { 'is-selected': value === 'normal' }]"
          @click="handleSelect('normal')"
        >
          <v-card-text class="pa-3 text-center">
            <div
              :class="['text-subtitle-1 font-weight-bold', value === 'normal' ? 'white--text' : '']"
            >
              通常
            </div>
            <div
              :class="['text-caption', value === 'normal' ? 'white--text' : 'text--secondary']"
            >
              税・サービス料を加算
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6">
        <v-card
          :outlined="value !== 'cut'"
          :color="value === 'cut' ? 'primary' : ''"
          :dark="value === 'cut'"
          :class="['tax-card', { 'is-selected': value === 'cut' }]"
          @click="handleSelect('cut')"
        >
          <v-card-text class="pa-3 text-center">
            <div
              :class="['text-subtitle-1 font-weight-bold', value === 'cut' ? 'white--text' : '']"
            >
              カット
            </div>
            <div
              :class="['text-caption', value === 'cut' ? 'white--text' : 'text--secondary']"
            >
              税・サービス料を加算しない
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'TaxChargeSelector',
  props: {
    value: { type: String, default: 'normal' },
  },
  emits: ['input'],
  setup(_, { emit }) {
    const handleSelect = v => {
      emit('input', v)
    }

    return { handleSelect }
  },
}
</script>

<style scoped>
.tax-card {
  cursor: pointer;
  min-height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.15s ease;
}
</style>
